import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Si on a un hash (ex: /#contact), on ne scroll pas tout en haut
    // On laisse le comportement naturel du navigateur essayer d'aller sur l'ancre.
    if (!hash) {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
